// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScannersPage_container__Lly8U {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  bottom: 50px;
  border-radius: 0px 0px 0px 0px;

}

/* Вкладки */
.ScannersPage_tabs__Kgia0 {
  display: flex;
  background-color: #ffffff;
  border-radius: 3px;
  overflow: hidden;
    background-color: transparent;
}

.ScannersPage_tab__2Ph\\+O {
  flex: 1 1;
  padding: 8px 12px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  background-color: transparent;
  border: none;
  transition: background-color 0.2s, color 0.2s;
}

.ScannersPage_tab__2Ph\\+O + .ScannersPage_tab__2Ph\\+O {
  border-left: 1px solid #ffffff;
}

.ScannersPage_tab__2Ph\\+O:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.ScannersPage_tab__2Ph\\+O.ScannersPage_active__1vTYd {
  background-color: #fff;
  color: #007bff;
  font-weight: bold;
  box-shadow: inset 0 -2px 0 #007bff;
}

/* Основная область */
.ScannersPage_body__pV5Jq {
  position: absolute;
  top: 65px;
  left: 0;
  right: 0;
  bottom: 0;
}

/* Список прогресса */
.ScannersPage_progressContainer__hogfE {
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  grid-auto-flow: row;
  row-gap: 8px;
  column-gap: 16px;
}

/* когда больше двух — две колонки по 50% */
.ScannersPage_twoColumns__CJcI2 {
  grid-template-columns: 1fr 1fr;   /* две равные колонки */
  grid-template-rows: auto auto;    /* ровно по две ячейки на колонку */
  grid-auto-flow: column;           /* заполняем по колонкам сверху вниз */
}
/* Обёртка одного бара */
.ScannersPage_barWrapper__lDJjc {
  position: relative;
  background-color: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
  height: 28px;
  display: flex;
  align-items: center;
}

/* Синяя заливка */
.ScannersPage_fill__pad5q {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #007bff;
  transition: width 0.3s ease;
  z-index: 1;
}

/* Контент поверх */
.ScannersPage_content__Qn4gq {
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 0 12px;
  display: flex;
  align-items: center;
}

/* Текст */
.ScannersPage_text__rIVAa {
  font-size: 14px;
  color: #fff;        /* белый текст против синей заливки */
  text-shadow: 0 0 5px rgba(0,0,0,1); /* чтобы был читаем на краях */
}

/* Если вам нужен чёрный текст, когда заливка низкая, можно добавить JS-класс */
.ScannersPage_content__Qn4gq.ScannersPage_lowFill__hX3q3 .ScannersPage_text__rIVAa {
  color: #000;
  text-shadow: none;
}

/* Обёртка для сканера */
.ScannersPage_scannerWrapper__N32ba {
  position: absolute;
  top: 65px;           /* отступ от верха модалки (под вкладками) */
  bottom: 5px;         /* оставляем место под кнопку */
  left: 26px;          /* отступ слева (как у вас было) */
  right: 26px;         /* отступ справа */
  overflow: hidden;    /* сам контейнер не скроллится */
}

/* плашка-успех */
.ScannersPage_bannerSuccess__nrx11 {
  padding: 5px;
  background-color: #00a12e;
  color: #ffffff;
}

/* плашка-ошибка */
.ScannersPage_bannerError__FjyuR {
  padding: 5px;
  background-color: rgb(255, 68, 68);
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/ScannersPage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,8BAA8B;;AAEhC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;IACd,6BAA6B;AACjC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,8BAA8B,IAAI,uBAAuB;EACzD,6BAA6B,KAAK,mCAAmC;EACrE,sBAAsB,YAAY,sCAAsC;AAC1E;AACA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,WAAW,SAAS,qCAAqC;EACzD,kCAAkC,EAAE,8BAA8B;AACpE;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS,YAAY,4CAA4C;EACjE,WAAW,UAAU,+BAA+B;EACpD,UAAU,WAAW,kCAAkC;EACvD,WAAW,UAAU,kBAAkB;EACvC,gBAAgB,KAAK,gCAAgC;AACvD;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB","sourcesContent":[".container {\r\n  position: absolute;\r\n  top: 42px;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 50px;\r\n  border-radius: 0px 0px 0px 0px;\r\n\r\n}\r\n\r\n/* Вкладки */\r\n.tabs {\r\n  display: flex;\r\n  background-color: #ffffff;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n    background-color: transparent;\r\n}\r\n\r\n.tab {\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #333;\r\n  background-color: transparent;\r\n  border: none;\r\n  transition: background-color 0.2s, color 0.2s;\r\n}\r\n\r\n.tab + .tab {\r\n  border-left: 1px solid #ffffff;\r\n}\r\n\r\n.tab:hover {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.tab.active {\r\n  background-color: #fff;\r\n  color: #007bff;\r\n  font-weight: bold;\r\n  box-shadow: inset 0 -2px 0 #007bff;\r\n}\r\n\r\n/* Основная область */\r\n.body {\r\n  position: absolute;\r\n  top: 65px;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n\r\n/* Список прогресса */\r\n.progressContainer {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  grid-auto-rows: auto;\r\n  grid-auto-flow: row;\r\n  row-gap: 8px;\r\n  column-gap: 16px;\r\n}\r\n\r\n/* когда больше двух — две колонки по 50% */\r\n.twoColumns {\r\n  grid-template-columns: 1fr 1fr;   /* две равные колонки */\r\n  grid-template-rows: auto auto;    /* ровно по две ячейки на колонку */\r\n  grid-auto-flow: column;           /* заполняем по колонкам сверху вниз */\r\n}\r\n/* Обёртка одного бара */\r\n.barWrapper {\r\n  position: relative;\r\n  background-color: #f0f0f0;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  height: 28px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Синяя заливка */\r\n.fill {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  background-color: #007bff;\r\n  transition: width 0.3s ease;\r\n  z-index: 1;\r\n}\r\n\r\n/* Контент поверх */\r\n.content {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 100%;\r\n  padding: 0 12px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Текст */\r\n.text {\r\n  font-size: 14px;\r\n  color: #fff;        /* белый текст против синей заливки */\r\n  text-shadow: 0 0 5px rgba(0,0,0,1); /* чтобы был читаем на краях */\r\n}\r\n\r\n/* Если вам нужен чёрный текст, когда заливка низкая, можно добавить JS-класс */\r\n.content.lowFill .text {\r\n  color: #000;\r\n  text-shadow: none;\r\n}\r\n\r\n/* Обёртка для сканера */\r\n.scannerWrapper {\r\n  position: absolute;\r\n  top: 65px;           /* отступ от верха модалки (под вкладками) */\r\n  bottom: 5px;         /* оставляем место под кнопку */\r\n  left: 26px;          /* отступ слева (как у вас было) */\r\n  right: 26px;         /* отступ справа */\r\n  overflow: hidden;    /* сам контейнер не скроллится */\r\n}\r\n\r\n/* плашка-успех */\r\n.bannerSuccess {\r\n  padding: 5px;\r\n  background-color: #00a12e;\r\n  color: #ffffff;\r\n}\r\n\r\n/* плашка-ошибка */\r\n.bannerError {\r\n  padding: 5px;\r\n  background-color: rgb(255, 68, 68);\r\n  color: #ffffff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScannersPage_container__Lly8U`,
	"tabs": `ScannersPage_tabs__Kgia0`,
	"tab": `ScannersPage_tab__2Ph+O`,
	"active": `ScannersPage_active__1vTYd`,
	"body": `ScannersPage_body__pV5Jq`,
	"progressContainer": `ScannersPage_progressContainer__hogfE`,
	"twoColumns": `ScannersPage_twoColumns__CJcI2`,
	"barWrapper": `ScannersPage_barWrapper__lDJjc`,
	"fill": `ScannersPage_fill__pad5q`,
	"content": `ScannersPage_content__Qn4gq`,
	"text": `ScannersPage_text__rIVAa`,
	"lowFill": `ScannersPage_lowFill__hX3q3`,
	"scannerWrapper": `ScannersPage_scannerWrapper__N32ba`,
	"bannerSuccess": `ScannersPage_bannerSuccess__nrx11`,
	"bannerError": `ScannersPage_bannerError__FjyuR`
};
export default ___CSS_LOADER_EXPORT___;
